// SaaSQuoteStatus.js
import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Button, Heading, Box, Tip } from 'grommet';
import { ShareOption} from 'grommet-icons';
import Iframe from 'react-iframe';

//function goNav(url) {
//  window.open(url, '_blank').focus();
//}

const OrdersScreenedComp = () => {
//  const size = useContext(ResponsiveContext);
//  const year = new Date().getFullYear();


  return (
    <Card height="450px" elevation="medium">
      <CardHeader pad={{ horizontal: 'medium', top: 'small', bottom: 'none' }}>
        <Box>
          <Heading margin="none" level={2} pad="none">
            Order Value Screens (Qlik- lab)
          </Heading>
        </Box>
      </CardHeader>
      <CardBody pad={{ horizontal: 'medium', top: 'none', bottom: 'small' }} gap="small" align="start" fill>
        <Iframe url="https://erebus.americas.hpqcorp.net/sso/single/?appid=1ec29006-e6e6-407c-8770-745cae97c10e&obj=6a9f123a-6d3a-4c5b-8f7d-e9602089a4ee&theme=hpewhite&opt=ctxmenu,currsel"
          width="100%" 
          height="100%"
          frameBorder="0"
          overflow="visible"
          allowFullScreen
          scrolling="no"
          id=""
          className=""/>
      </CardBody>
      <CardFooter pad={{horizontal: "small"}} background="light-2">
        <Tip content="Share with colleagues...">
          <Button icon={<ShareOption color="plain" />} 
                  href="mailto:?subject=GT Cockpit...&body=https://gt.it.hpe.com"
                  hoverIndicator />
        </Tip>
      </CardFooter>      
    </Card>
  );
};

export { OrdersScreenedComp as OrdersScreened };
